import { connect } from 'react-redux';

import Photos from 'Sections/Room/components/Steps/Photos';

import Actions from 'datamodel/RoomList/actions';
import {
  getRoomIdSelector,
  getRoomPhotosSelector,
  getRoomLocationSelector,
  getRoomBadiPlusExternalId,
} from 'datamodel/RoomList/selectors';
import { getBadiPlusManager } from 'datamodel/User/selectors';
import { getProfessionalPhotosSelector } from 'datamodel/Features/selectors';

const mapStateToProps = (state) => ({
  roomId: getRoomIdSelector(state),
  storePhotos: getRoomPhotosSelector(state),
  isProPhotosEnabled: getProfessionalPhotosSelector(state),
  city: getRoomLocationSelector(state).city,
  badiPlusManager: getBadiPlusManager(state),
  badiPlusExternalId: getRoomBadiPlusExternalId(state),
});

const mapDispatchToProps = {
  setRoomPhotos: Actions.setRoomPhotos,
  setRoomBadiPlusExternalId: Actions.setRoomBadiPlusExternalId,
};

export default connect(mapStateToProps, mapDispatchToProps)(Photos);
